/* ==========================================================================
   Shop the Look article (sections/main-article-shop-the-look.liquid)

   - Sidebar swatches pick each product's shade; the pick follows the product
     everywhere it appears (sidebar card, step row, totals).
   - Add to Bag / Add all post the picked variants to /cart/add.js: Rebuy's
     Smart Cart opens off that request, and /cart itself redirects home on
     this store, so a native form submit would lose the shopper.
   - The sidebar card for the step being read wears a READING NOW badge.
   - Product links in the copy scroll to the product's card in the band
     (their href still goes to the product page without this script).
   ========================================================================== */
(function () {
  'use strict';

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function init(root) {
    if (root.__stl) return;
    root.__stl = true;

    var S = {};
    try { S = JSON.parse(root.querySelector('[data-stl-strings]').textContent); } catch (e) { /* defaults below */ }
    var format = root.getAttribute('data-money-format');
    var live = root.querySelector('[data-stl-live]');

    function say(text) {
      if (!live || !text) return;
      live.textContent = '';
      window.setTimeout(function () { live.textContent = text; }, 50);
    }

    // Picked variant per block id, seeded from the server's starting shade.
    var picks = {};
    $$('[data-stl-product]', root).forEach(function (card) {
      picks[card.getAttribute('data-stl-product')] = {
        id: card.getAttribute('data-stl-default'),
        price: parseInt(card.getAttribute('data-stl-default-price'), 10) || 0,
        available: card.getAttribute('data-stl-default-available') === 'true'
      };
    });

    // Everything on the page that shows a product's pick: its sidebar card and step rows.
    function views(blockId) {
      return $$('[data-stl-product="' + blockId + '"], [data-stl-for="' + blockId + '"]', root);
    }

    function refreshTotals() {
      var total = 0;
      var any = false;
      Object.keys(picks).forEach(function (k) {
        if (picks[k].available) { total += picks[k].price; any = true; }
      });
      $$('[data-stl-total]', root).forEach(function (el) { el.textContent = money(total, format); });
      $$('[data-stl-add-all]', root).forEach(function (btn) { btn.disabled = !any; });
    }

    function applyPick(blockId, sw) {
      var pick = {
        id: sw.getAttribute('data-variant-id'),
        price: parseInt(sw.getAttribute('data-price'), 10) || 0,
        available: sw.getAttribute('data-available') === 'true',
        shade: sw.getAttribute('data-shade'),
        img: sw.getAttribute('data-img')
      };
      picks[blockId] = pick;

      var card = root.querySelector('[data-stl-product="' + blockId + '"]');
      if (card) {
        $$('[data-stl-swatch]', card).forEach(function (b) { b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'); });
      }
      views(blockId).forEach(function (v) {
        $$('[data-stl-shade]', v).forEach(function (el) { el.textContent = pick.shade; });
        $$('[data-stl-price]', v).forEach(function (el) { el.textContent = money(pick.price, format); });
        if (pick.img) $$('img[data-stl-img]', v).forEach(function (img) { img.src = pick.img; });
        var buttons = v.matches('[data-stl-add]') ? [v] : $$('[data-stl-add]', v);
        buttons.forEach(function (btn) {
          btn.disabled = !pick.available;
          var label = btn.querySelector('[data-stl-label]');
          if (label) label.textContent = pick.available ? (btn.classList.contains('stl__inline') ? S.inline : S.add) || 'Add to bag' : S.soldOut || 'Sold out';
        });
      });
      refreshTotals();
    }

    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-stl-swatch]');
      if (sw && root.contains(sw)) {
        var card = sw.closest('[data-stl-product]');
        if (card) applyPick(card.getAttribute('data-stl-product'), sw);
        return;
      }
      var one = e.target.closest('[data-stl-add]');
      if (one && root.contains(one)) {
        var pick = picks[one.getAttribute('data-stl-add')];
        if (pick && pick.available) addToBag([pick.id], one);
        return;
      }
      var all = e.target.closest('[data-stl-add-all]');
      if (all && root.contains(all)) {
        var ids = Object.keys(picks).filter(function (k) { return picks[k].available; }).map(function (k) { return picks[k].id; });
        if (ids.length) addToBag(ids, all);
      }
    });

    function setLabel(btn, text) {
      var label = btn.querySelector('[data-stl-label]');
      if (!label) return null;
      var was = label.textContent;
      label.textContent = text;
      return was;
    }

    function bumpCartCount() {
      fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $$('[data-js-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () { /* the count is decoration; the add already worked */ });
    }

    function addToBag(ids, btn) {
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      var was = setLabel(btn, S.adding || 'Adding…');
      var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });

      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          bumpCartCount();
          // Rebuy opens itself off the /cart/add.js request. Only nudge it once
          // it is ready: show() while it is initialising wedges it.
          var sc = window.Rebuy && window.Rebuy.SmartCart;
          if (sc && sc.status === 'ready' && typeof sc.show === 'function') sc.show();
          say(S.addedLive || 'Added to your bag.');
          setLabel(btn, S.added || 'Added');
          window.setTimeout(function () { if (was != null) setLabel(btn, was); }, 1800);
        })
        .catch(function () {
          if (was != null) setLabel(btn, was);
          say(S.addFailed || 'Sorry, that could not be added to your bag. Please try again.');
        })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        });
    }

    // Reading now: the step crossing the band 30–50% down the viewport.
    if (root.hasAttribute('data-stl-highlight') && 'IntersectionObserver' in window) {
      var steps = $$('[data-stl-step]', root);
      var badges = $$('[data-stl-badge]', root);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.getAttribute('data-stl-step');
          badges.forEach(function (b) {
            b.hidden = b.closest('[data-stl-product]').getAttribute('data-stl-product') !== id;
          });
        });
      }, { rootMargin: '-30% 0px -50% 0px', threshold: 0 });
      steps.forEach(function (s) { io.observe(s); });
    }

    // Product links in the copy scroll to that product's band card.
    var targets = {};
    $$('[data-stl-handle]', root).forEach(function (el) { targets[el.getAttribute('data-stl-handle')] = el; });
    $$('.stl__rte a[href*="/products/"]', root).forEach(function (a) {
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      var target = m && targets[decodeURIComponent(m[1])];
      if (!target) return;
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        target.focus({ preventScroll: true });
        if (window.history && history.replaceState) history.replaceState(null, '', '#' + target.id);
      });
    });

    refreshTotals();
  }

  function boot() { $$('[data-stl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
